import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { showRunFlowDialog } from '../actions/RunFlowAction';
import { RunFlowReduxAction } from '../actions/RunFlowReduxAction';
import { getFlowListItemInfos } from '../FlowsSagaHelpers';
import { FlowListItemInfo } from '../models/FlowInfo';

export function openRunFlowsDialog(flowListItemInfos: FlowListItemInfo[]): Promise<IResult> {
  const flowSet = Set.fromIdItemArray(flowListItemInfos);
  return showRunFlowDialog(flowSet);
}

export function* handleRunFlow(action: RunFlowReduxAction): SagaIterator {
  try {
    if (action.selectedContent && action.selectedContent[0].contentType === 'flow') {
      const flowListItemInfos = yield call(getFlowListItemInfos, action.selectedContent);
      yield call(openRunFlowsDialog, flowListItemInfos);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
